module.exports = __webpack_public_path__ + "static/media/client-16.b29faf0e.jpg";